import React from "react";
import Layout from "../components/Layout";
import { CalendarVerificador } from "../components";
const CalendarioVerificador = () => {
  return (
	<>
	  <Layout />
	  <div>
		<CalendarVerificador />
	  </div>
	</>
  );
};

export default CalendarioVerificador;
